module.exports = __webpack_public_path__ + "static/media/traceability.8a799d3a.jpg";